import { AppLayoutVariant as e } from "./AppLayoutVariant.mjs";
import { createContext as t, useContext as n, useEffect as r, useMemo as i, useState as a } from "react";
import { Fragment as o, jsx as s } from "react/jsx-runtime";
//#region src/AppLayoutContext.tsx
var c = t(null), l = c, u = ({ defaultLayout: t = e.TopNavigation, children: n }) => {
	let [r, o] = a(t), l = i(() => ({
		layout: r,
		defaultLayout: t,
		setLayout: o
	}), [r, t]);
	return /* @__PURE__ */ s(c.Provider, {
		value: l,
		children: n
	});
}, d = () => {
	let e = n(c);
	if (!e) throw Error("useAppLayoutContext must be used inside <AppLayoutProvider>");
	return e;
}, f = (e) => {
	let t = n(c), i = t?.setLayout, a = t?.defaultLayout;
	r(() => {
		if (!(!i || e === void 0)) return i(e), () => {
			a !== void 0 && i(a);
		};
	}, [
		i,
		a,
		e
	]);
}, p = ({ layout: e, children: t }) => (f(e), /* @__PURE__ */ s(o, { children: t }));
//#endregion
export { u as AppLayoutProvider, p as ApplyAppLayout, l as _AppLayoutContext, d as useAppLayoutContext, f as useSetAppLayout };
